import FileBarChart from "./FileBarChart";

export {FileBarChart}
export default FileBarChart